module.exports = {
  createNetworkTrackerObject: () => {},
  Timing: function Timing () {
    return {
      getTiming: () => {}
    }
  },
  isElectron: () => false
}
